import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {FetchImagesSubTaskProcess, TaskState} from "../types/taskFlow.types";

const initialState: TaskState = {
    dialogImageInfo: null,
    level2TaskId: null,
    canvasImage: null,
    snackbarOpen: {open: false, message: ''},
    globalMessage: ''
};

export const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        setCurrentDialogImageInfo: (state, action: PayloadAction<FetchImagesSubTaskProcess | null>) => {
            state.dialogImageInfo = action.payload;
        },
        setCurrentLevel2TaskId: (state, action: PayloadAction<number | null>) => {
            state.level2TaskId = action.payload;
        },
        setSelectCanvasImage: (state, action: PayloadAction<string[] | null>) => {
            if (action.payload) {
                const stateCanvasImage = state.canvasImage ? [...state.canvasImage, ...action.payload] : action.payload;
                if (stateCanvasImage.length > 10) {
                    state.snackbarOpen = {open: true, message: 'UPLOAD_IMAGE_LIMIT'}
                    return;
                }
                state.canvasImage = stateCanvasImage;
            } else {
                state.canvasImage = null;
            }
        },
        removeLoadingImage: (state, action: PayloadAction<number>) => {
            let removedCount = action.payload ?? 0;
            const newCanvasImage = state.canvasImage?.filter(item => {
                if (item === 'loading' && removedCount > 0) {
                    removedCount--;
                    return false;
                }
                return true;
            });
            state.canvasImage = newCanvasImage ? newCanvasImage : null;
        },
        coverSelectCanvasImage: (state, action: PayloadAction<string[] | null>) => {
            if (action.payload && action.payload.length > 10) {
                state.snackbarOpen = {open: true, message: 'UPLOAD_IMAGE_LIMIT'}
                return;
            }
            state.canvasImage = action.payload ? action.payload : null;
        },
        setSnackbarOpen: (state, action: PayloadAction<{open: boolean, message: string}>) => {
            state.snackbarOpen = action.payload
        },
        setGlobalMessage: (state, action: PayloadAction<string>) => {
            state.globalMessage = action.payload
        }
    }
});

export const {
    setCurrentDialogImageInfo,
    setCurrentLevel2TaskId,
    setSelectCanvasImage,
    setSnackbarOpen,
    coverSelectCanvasImage,
    removeLoadingImage,
    setGlobalMessage
} = taskSlice.actions;

export default taskSlice.reducer;